{
    "404": "요청하신 리소스를 찾을 수 없습니다.",
    "500": "알 수 없는 서버 오류가 발생했습니다. 자세한 내용은 로그를 확인하세요.",
    "general_unknown": "알 수 없는 오류가 발생했습니다. 자세한 내용은 로그를 확인하세요.",
    "general_mock": "테스트에 사용된 모의 컨트롤러에서 발생하는 일반적인 오류입니다.",
    "general_access_forbidden": "이 API에 대한 액세스는 금지되어 있습니다.",
    "general_unknown_origin": "알 수 없는 출처에서 요청이 시작되었습니다. 이 도메인을 신뢰하는 경우 앱쓰기 콘솔에서 신뢰할 수 있는 플랫폼으로 등록하세요.",
    "general_api_disabled": "요청된 API가 비활성화되었습니다. 앱쓰기 콘솔에서 API를 활성화할 수 있습니다.",
    "general_service_disabled": "요청된 서비스가 비활성화되었습니다. 앱쓰기 콘솔에서 서비스를 활성화할 수 있습니다.",
    "general_unauthorized_scope": "현재 사용자 또는 API 키에 요청된 리소스에 액세스하는 데 필요한 범위가 없습니다.",
    "general_rate_limit_exceeded": "현재 엔드포인트의 속도 제한을 초과했습니다. 잠시 후 다시 시도해 주세요.",
    "general_smtp_disabled": "Appwrite 인스턴스에서 SMTP가 비활성화되어 있습니다. <a href=\"/docs/email-delivery\">SMTP 설정에 대한 자세한 내용은</a> 문서에서 확인할 수 있습니다.",
    "general_phone_disabled": "전화 공급자가 구성되지 않았습니다. 앱쓰기 서버의 _APP_SMS_PROVIDER 환경 변수를 확인하세요.",
    "general_argument_invalid": "요청에 잘못된 인수가 하나 이상 포함되어 있습니다. 엔드포인트 설명서를 참조하세요.",
    "general_query_limit_exceeded": "현재 속성에 대한 쿼리 제한을 초과했습니다. 단일 속성에 100개 이상의 쿼리 값을 사용하는 것은 금지되어 있습니다.",
    "general_query_invalid": "쿼리 구문이 유효하지 않습니다. 쿼리를 확인한 후 다시 시도하세요.",
    "general_route_not_found": "요청하신 경로를 찾을 수 없습니다. API 문서를 참조하여 다시 시도해 보세요.",
    "general_cursor_not_found": "커서가 유효하지 않습니다. 커서가 가리키는 항목이 삭제된 경우 이 문제가 발생할 수 있습니다.",
    "general_server_error": "내부 서버 오류가 발생했습니다.",
    "general_protocol_unsupported": "현재 프로토콜로는 요청을 이행할 수 없습니다. 앱옵션_포스_HTTPS 환경 변수의 값을 확인해 주세요.",
    "general_codes_disabled": "이 서버에서는 초대 코드를 사용할 수 없습니다. 서버 관리자에게 문의하세요.",
    "general_usage_disabled": "사용 통계가 구성되지 않았습니다. Appwrite 서버의 _APP_USAGE_STATS 환경 변수 값을 확인해 주세요.",
    "general_not_implemented": "이 방법은 아직 완전히 구현되지 않았습니다. 이 방법이 실수라고 생각되면 Appwrite 서버 버전을 업그레이드하세요.",
    "general_invalid_email": "값은 유효한 이메일 주소여야 합니다.",
    "general_invalid_phone": "값은 유효한 전화번호여야 합니다. 이 번호의 형식은 선행 '+'와 국가 코드(예: +16175551212)로 지정합니다.",
    "general_region_access_denied": "법적 요구 사항으로 인해 귀하의 위치는 지원되지 않습니다.",
    "general_bad_request": "요청을 처리하는 동안 오류가 발생했습니다. 입력을 확인하고 다시 시도해 주세요.",
    "user_count_exceeded": "현재 프로젝트가 최대 사용자 수를 초과했습니다. 앱쓰기 콘솔에서 사용자 제한을 확인하세요.",
    "user_console_count_exceeded": "콘솔 가입이 제한되었습니다. 관리자에게 문의하여 콘솔 가입 제한을 업데이트하려면 _APP_CONSOLE_WHITELIST_ROOT를 \"사용 안 함\"으로 설정하면 됩니다.",
    "user_jwt_invalid": "JWT 토큰이 유효하지 않습니다. 올바른 토큰이 사용되고 있는지 확인하려면 X-Appwrite-JWT 헤더의 값을 확인하세요.",
    "user_already_exists": "이 프로젝트에 동일한 아이디, 이메일 또는 휴대폰을 가진 사용자가 이미 존재합니다.",
    "user_blocked": "현재 사용자가 차단되었습니다. 사용자 API의 '사용자 상태 업데이트' 엔드포인트 또는 앱쓰기 콘솔의 인증 섹션에서 요청하여 사용자를 차단 해제할 수 있습니다.",
    "user_invalid_token": "요청에 전달된 토큰이 잘못되었습니다.",
    "user_password_reset_required": "현재 사용자는 비밀번호를 재설정해야 합니다.",
    "user_email_not_whitelisted": "콘솔 등록은 특정 이메일로만 제한됩니다. 자세한 내용은 관리자에게 문의하세요.",
    "user_invalid_code": "지정한 코드가 유효하지 않습니다. 자세한 내용은 관리자에게 문의하세요.",
    "user_ip_not_whitelisted": "콘솔 등록은 특정 IP로 제한됩니다. 자세한 내용은 관리자에게 문의하세요.",
    "user_invalid_credentials": "자격 증명이 잘못되었습니다. 이메일과 비밀번호를 확인하세요.",
    "user_anonymous_console_prohibited": "콘솔 프로젝트에는 익명 사용자를 만들 수 없습니다.",
    "user_session_already_exists": "세션이 활성화되어 있으면 세션 생성이 금지됩니다.",
    "user_not_found": "요청한 ID를 가진 사용자를 찾을 수 없습니다.",
    "user_email_already_exists": "현재 프로젝트에 동일한 이메일을 가진 사용자가 이미 존재합니다.",
    "user_password_mismatch": "비밀번호가 일치하지 않습니다. 비밀번호를 확인한 후 비밀번호를 확인해 주세요.",
    "password_recently_used": "사용하려는 비밀번호가 이전 비밀번호와 유사합니다. 보안을 위해 다른 비밀번호를 선택하고 다시 시도하세요.",
    "password_personal_data": "사용하려는 비밀번호에 이름, 이메일, 휴대폰 또는 사용자 아이디에 대한 참조가 포함되어 있습니다. 보안을 위해 다른 비밀번호를 선택하고 다시 시도하세요.",
    "user_session_not_found": "현재 사용자 세션을 찾을 수 없습니다.",
    "user_identity_not_found": "ID를 찾을 수 없습니다. 먼저 OAuth 공급업체로 로그인하여 ID를 생성하세요.",
    "user_unauthorized": "현재 사용자에게 요청된 작업을 수행할 수 있는 권한이 없습니다.",
    "user_auth_method_unsupported": "요청된 인증 방법이 비활성화되었거나 지원되지 않습니다. 앱쓰기 콘솔에서 지원되는 인증 방법을 확인하세요.",
    "user_phone_already_exists": "현재 프로젝트에 동일한 전화번호를 가진 사용자가 이미 존재합니다.",
    "user_recovery_codes_already_exists": "현재 사용자가 이미 생성한 복구 코드는 보안상의 이유로 한 번만 읽을 수 있습니다.",
    "user_authenticator_not_found": "현재 사용자에서 인증자를 찾을 수 없습니다.",
    "user_recovery_codes_not_found": "현재 사용자에서 복구 코드를 찾을 수 없습니다.",
    "user_authenticator_already_verified": "이 인증자는 현재 사용자에 대해 이미 확인되었습니다.",
    "user_phone_not_found": "현재 사용자에게 계정에 연결된 휴대폰 번호가 없습니다.",
    "user_missing_id": "OAuth2 공급자의 ID가 누락되었습니다.",
    "user_more_factors_required": "로그인 프로세스를 완료하려면 더 많은 요소가 필요합니다.",
    "user_challenge_required": "이 작업을 완료하려면 최근에 성공한 도전이 필요합니다. 도전은 5분 동안 최근 도전으로 간주됩니다.",
    "user_oauth2_bad_request": "OAuth2 공급자가 잘못된 요청을 거부했습니다.",
    "user_oauth2_unauthorized": "OAuth2 공급자가 승인되지 않은 요청을 거부했습니다.",
    "user_oauth2_provider_error": "OAuth2 공급자가 일부 오류를 반환했습니다.",
    "user_email_already_verified": "사용자 이메일이 이미 확인되었습니다.",
    "user_phone_already_verified": "사용자 전화가 이미 확인되었습니다.",
    "user_deletion_prohibited": "멤버십이 활성화된 사용자의 경우 사용자 삭제가 허용되지 않습니다. 계정을 삭제하기 전에 확인된 모든 멤버십을 삭제하세요.",
    "user_target_not_found": "대상을 찾을 수 없습니다.",
    "user_target_already_exists": "동일한 ID를 가진 대상이 이미 존재합니다.",
    "user_key_and_session_set": "동일한 요청에 사용되는 API 키와 세션. 설정 세션` 또는 `설정 키`를 사용합니다. SSR 문서에서 어떤 인증 방법을 사용할지 알아보세요: https://appwrite.io/docs/products/auth/server-side-rendering",
    "api_key_expired": "동적 API 키가 만료되었습니다. 동적 API 키를 실행 기간보다 오래 사용하지 마세요.",
    "team_not_found": "요청하신 ID를 가진 팀을 찾을 수 없습니다.",
    "team_invite_already_exists": "사용자가 이미 초대되었거나 이미 이 팀의 멤버입니다.",
    "team_invite_not_found": "요청하신 팀 초대를 찾을 수 없습니다.",
    "team_invalid_secret": "팀 초대 비밀이 유효하지 않습니다. 새 초대를 요청하고 다시 시도하세요.",
    "team_membership_mismatch": "멤버십 ID는 팀 ID에 속하지 않습니다.",
    "team_invite_mismatch": "초대가 현재 사용자의 소유가 아닙니다.",
    "team_already_exists": "요청하신 아이디를 가진 팀이 이미 있습니다. 다른 ID를 선택하고 다시 시도하세요.",
    "membership_not_found": "요청하신 ID를 가진 멤버십을 찾을 수 없습니다.",
    "membership_already_confirmed": "회원 가입이 이미 확인되었습니다.",
    "avatar_set_not_found": "요청하신 아바타 세트를 찾을 수 없습니다.",
    "avatar_not_found": "요청 아바타를 찾을 수 없습니다.",
    "avatar_image_not_found": "요청하신 이미지를 URL에서 찾을 수 없습니다.",
    "avatar_remote_url_failed": "요청된 URL에서 파비콘을 가져오지 못했습니다.",
    "avatar_icon_not_found": "요청하신 파비콘을 찾을 수 없습니다.",
    "storage_file_already_exists": "요청된 ID를 가진 저장소 파일이 이미 존재합니다.",
    "storage_file_not_found": "요청하신 파일을 찾을 수 없습니다.",
    "storage_device_not_found": "요청하신 저장 장치를 찾을 수 없습니다.",
    "storage_file_empty": "엔드포인트에 전달된 빈 파일입니다.",
    "storage_file_type_unsupported": "지정된 파일 확장자는 지원되지 않습니다.",
    "storage_invalid_file_size": "파일 크기가 유효하지 않거나 허용된 최대 크기를 초과했습니다. 파일 또는 _APP_STORAGE_LIMIT 환경 변수의 값을 확인하세요.",
    "storage_invalid_file": "업로드한 파일이 유효하지 않습니다. 파일을 확인한 후 다시 시도하세요.",
    "storage_bucket_already_exists": "요청한 ID를 가진 스토리지 버킷이 이미 존재합니다. 다른 ID로 다시 시도하거나 ID.unique()를 사용하여 고유 ID를 생성하세요.",
    "storage_bucket_not_found": "요청하신 ID가 있는 스토리지 버킷을 찾을 수 없습니다.",
    "storage_invalid_content_range": "콘텐츠 범위가 유효하지 않습니다. Content-Range 헤더의 값을 확인하세요.",
    "storage_invalid_range": "요청된 범위가 만족스럽지 않습니다. 범위 헤더의 값을 확인하세요.",
    "storage_invalid_appwrite_id": "x-appwrite-id 헤더의 값이 잘못되었습니다. x-appwrite-id 헤더의 값이 고유()가 아닌 유효한 ID인지 확인하세요.",
    "storage_file_not_public": "요청된 파일은 공개적으로 읽을 수 없습니다.",
    "installation_not_found": "요청한 ID로 설치할 수 없습니다. ID가 올바른지 확인하거나 설치를 생성하세요.",
    "provider_repository_not_found": "요청하신 ID가 있는 VCS(버전 관리 시스템) 리포지토리를 찾을 수 없습니다. ID가 올바른지, 제공한 설치 ID에 속하는지 확인하세요.",
    "repository_not_found": "요청하신 ID의 리포지토리를 찾을 수 없습니다. ID가 올바른지 확인하거나 리포지토리를 생성하세요.",
    "provider_contribution_conflict": "외부 기여는 이미 승인되었습니다.",
    "general_provider_failure": "VCS(버전 관리 시스템) 공급자가 요청을 처리하지 못했습니다. VCS 제공업체의 오류로 추정됩니다. 다시 시도하거나 지원팀에 문의하여 자세한 정보를 확인하세요.",
    "function_not_found": "요청한 ID의 함수를 찾을 수 없습니다.",
    "function_runtime_unsupported": "앱쓰기 함수에 대한 엔트리포인트가 누락되었습니다. 배포할 때 지정하거나 함수의 '설정' > '구성' > '엔트리포인트'에서 엔트리포인트를 업데이트하세요.",
    "function_synchronous_timeout": "동기식 함수 실행 시간이 초과되었습니다. 대신 비동기 실행을 사용하거나 실행 시간이 30초를 초과하지 않도록 하세요.",
    "function_template_not_found": "요청한 ID의 함수 템플릿을 찾을 수 없습니다.",
    "build_not_found": "요청된 ID로 빌드를 찾을 수 없습니다.",
    "build_not_ready": "요청된 ID로 빌드가 빌드 중이며 실행할 준비가 되지 않았습니다.",
    "build_in_progress": "요청하신 ID로 빌드가 이미 진행 중입니다. 다시 시도하기 전에 잠시 기다려 주세요.",
    "build_already_completed": "요청된 ID로 빌드가 이미 완료되었으며 취소할 수 없습니다.",
    "deployment_not_found": "요청된 ID로 배포를 찾을 수 없습니다.",
    "execution_not_found": "요청된 ID로 실행할 수 없습니다.",
    "execution_in_progress": "진행 중인 실행은 삭제할 수 없습니다. 실행이 완료될 때까지 기다렸다가 삭제하세요.",
    "database_not_found": "데이터베이스를 찾을 수 없습니다.",
    "database_already_exists": "데이터베이스가 이미 존재합니다.",
    "database_timeout": "데이터베이스 시간이 초과되었습니다. 쿼리를 조정하거나 인덱스를 추가해 보세요.",
    "collection_not_found": "요청하신 ID로 컬렉션을 찾을 수 없습니다.",
    "collection_already_exists": "요청된 ID를 가진 컬렉션이 이미 존재합니다. 다른 ID로 다시 시도하거나 ID.unique()를 사용하여 고유 ID를 생성하세요.",
    "collection_limit_exceeded": "최대 컬렉션 수에 도달했습니다.",
    "document_not_found": "요청한 ID가 있는 문서를 찾을 수 없습니다.",
    "document_invalid_structure": "문서 구조가 잘못되었습니다. 속성이 컬렉션 정의와 일치하는지 확인하세요.",
    "document_missing_data": "문서 데이터가 누락되었습니다. 문서 데이터가 채워진 상태에서 다시 시도하세요.",
    "document_missing_payload": "문서 데이터 및 권한이 누락되었습니다. 업데이트하려면 문서 데이터 또는 권한을 제공해야 합니다.",
    "document_already_exists": "요청된 ID의 문서가 이미 존재합니다. 다른 ID로 다시 시도하거나 ID.unique()를 사용하여 고유 ID를 생성하세요.",
    "document_update_conflict": "원격 문서가 로컬 문서보다 최신 버전입니다.",
    "document_delete_restricted": "다른 문서에서 참조하고 있기 때문에 문서를 삭제할 수 없습니다.",
    "attribute_not_found": "요청된 ID의 속성을 찾을 수 없습니다.",
    "attribute_unknown": "인덱스에 필요한 속성을 찾을 수 없습니다. 모든 속성이 사용 가능한 상태인지 확인하세요.",
    "attribute_not_available": "요청하신 속성을 아직 사용할 수 없습니다. 나중에 다시 시도해 주세요.",
    "attribute_format_unsupported": "요청된 속성 형식은 지원되지 않습니다.",
    "attribute_default_unsupported": "배열 또는 필수 속성에는 기본값을 설정할 수 없습니다.",
    "attribute_already_exists": "요청한 키의 어트리뷰트가 이미 존재합니다. 속성 키는 고유해야 하며 다른 키로 다시 시도하세요.",
    "attribute_limit_exceeded": "최대 속성 수에 도달했습니다.",
    "attribute_value_invalid": "속성 값이 잘못되었습니다. 속성의 유형, 범위 및 값을 확인하세요.",
    "attribute_type_invalid": "속성 유형이 잘못되었습니다.",
    "relationship_value_invalid": "관계 값이 유효하지 않습니다.",
    "attribute_invalid_resize": "기존 데이터가 새 크기에 비해 너무 커서 기존 데이터를 잘라낸 후 다시 시도하세요.",
    "index_not_found": "요청한 ID의 인덱스를 찾을 수 없습니다.",
    "index_limit_exceeded": "최대 인덱스 수에 도달했습니다.",
    "index_already_exists": "요청한 키의 인덱스가 이미 존재합니다. 다른 키로 다시 시도하세요.",
    "index_invalid": "인덱스가 잘못되었습니다.",
    "project_not_found": "요청한 ID의 프로젝트를 찾을 수 없습니다. 올바른 프로젝트 ID가 사용되고 있는지 X-Appwrite-Project 헤더의 값을 확인하세요.",
    "project_already_exists": "요청한 ID를 가진 프로젝트가 이미 존재합니다. 다른 ID로 다시 시도하거나 ID.unique()를 사용하여 고유 ID를 생성하세요.",
    "project_provider_disabled": "선택한 OAuth 공급자가 비활성화되었습니다. 앱쓰기 콘솔을 사용하여 OAuth 공급자를 활성화할 수 있습니다.",
    "project_provider_unsupported": "선택한 OAuth 공급자가 지원되지 않습니다. 지원되는 OAuth 공급자의 전체 목록은 <a href=\"/docs/client/account?sdk=web-default#accountCreateOAuth2Session\">OAuth2 세션 만들기 문서를</a> 참조하세요.",
    "project_invalid_success_url": "OAuth 성공에 대한 리디렉션 URL이 잘못되었습니다.",
    "project_invalid_failure_url": "OAuth 실패에 대한 잘못된 리디렉션 URL입니다.",
    "project_reserved_project": "프로젝트 ID가 예약되어 있습니다. 다른 프로젝트 ID를 선택해 주세요.",
    "project_key_expired": "프로젝트 키가 만료되었습니다. 앱쓰기 콘솔을 사용하여 새 키를 생성하세요.",
    "router_host_not_found": "호스트를 신뢰할 수 없습니다. 사용자 지정 도메인을 구성하지 않았기 때문에 이 문제가 발생할 수 있습니다. 먼저 프로젝트에 사용자 지정 도메인을 추가하고 다시 시도하세요.",
    "router_domain_not_configured": "앱 도메인, 앱 도메인 타겟, 앱 도메인 함수 환경 변수가 구성되지 않았습니다. localhost가 아닌 다른 IP 주소나 호스트명을 통해 앱쓰기 콘솔에 액세스하려면 먼저 도메인 환경 변수를 구성하세요. 이 값은 203.0.113.0과 같은 IP 또는 example.com과 같은 호스트 이름일 수 있습니다.",
    "rule_resource_not_found": "리소스를 찾을 수 없습니다. resourceId 및 resourceType이 올바른지 또는 리소스가 실제로 존재하는지 확인하세요.",
    "rule_not_found": "요청한 ID의 규칙을 찾을 수 없습니다. 입력한 ID가 올바른지 또는 해당 규칙이 실제로 존재하는지 확인하세요.",
    "rule_already_exists": "도메인이 이미 사용 중입니다. 다른 도메인으로 다시 시도하세요.",
    "rule_verification_failed": "도메인 인증에 실패했습니다. DNS 레코드가 올바른지 확인한 후 다시 시도하세요.",
    "project_smtp_config_invalid": "제공된 SMTP 구성이 잘못되었습니다. 구성된 값을 확인한 후 다시 시도하세요.",
    "project_template_default_deletion": "기본 템플릿은 삭제할 수 없습니다. 템플릿 변경 사항을 초기화하려는 경우 이미 초기화되었으므로 이 오류는 무시해도 됩니다.",
    "project_region_unsupported": "요청한 지역이 비활성 상태이거나 지원되지 않습니다. 앱_지역 환경 변수의 값을 확인하세요.",
    "webhook_not_found": "요청된 ID의 웹훅을 찾을 수 없습니다.",
    "key_not_found": "요청한 ID가 있는 키를 찾을 수 없습니다.",
    "platform_not_found": "요청하신 ID를 가진 플랫폼을 찾을 수 없습니다.",
    "variable_not_found": "요청된 ID를 가진 변수를 찾을 수 없습니다.",
    "variable_already_exists": "이 프로젝트에 동일한 ID를 가진 변수가 이미 있습니다. 다른 ID로 다시 시도하세요.",
    "graphql_no_query": "매개변수 '쿼리'는 선택 사항이 아닙니다.",
    "graphql_too_many_queries": "쿼리가 너무 많습니다.",
    "migration_not_found": "요청하신 ID로 마이그레이션을 찾을 수 없습니다. 제공한 ID가 올바른지 확인한 후 다시 시도하세요.",
    "migration_already_exists": "요청한 ID를 사용한 마이그레이션이 이미 존재합니다. 다른 ID로 다시 시도하세요.",
    "migration_in_progress": "마이그레이션이 이미 진행 중입니다. 앱쓰기 콘솔의 \"설정\" > \"마이그레이션\"에서 마이그레이션 상태를 확인할 수 있습니다.",
    "realtime_message_format_invalid": "메시지 형식이 올바르지 않습니다.",
    "realtime_policy_violation": "정책 위반.",
    "realtime_too_many_messages": "메시지가 너무 많습니다.",
    "migration_provider_error": "공급자 측에서 오류가 발생했습니다. 나중에 다시 시도해 주세요.",
    "health_queue_size_exceeded": "대기열 크기 임계값에 도달했습니다.",
    "health_certificate_expired": "지정한 도메인의 SSL 인증서가 만료되어 더 이상 유효하지 않습니다.",
    "health_invalid_host": "지정한 도메인에 연결하지 못했습니다. 도메인 이름을 확인하고 서버가 실행 중이고 액세스할 수 있는지 확인하세요.",
    "provider_not_found": "요청된 ID를 가진 공급자를 찾을 수 없습니다.",
    "provider_already_exists": "요청된 ID를 가진 공급자가 이미 존재합니다.",
    "provider_incorrect_type": "요청된 ID를 가진 공급자의 유형이 올바르지 않습니다.",
    "provider_missing_credentials": "요청된 ID를 가진 공급자의 자격 증명이 누락되었습니다.",
    "topic_not_found": "요청 ID가 있는 토픽을 찾을 수 없습니다.",
    "topic_already_exists": "요청 ID가 있는 토픽이 이미 존재합니다.",
    "subscriber_not_found": "요청 ID를 가진 구독자를 찾을 수 없습니다.",
    "subscriber_already_exists": "요청 ID를 가진 구독자가 이미 존재합니다.",
    "message_not_found": "요청된 ID의 메시지를 찾을 수 없습니다.",
    "message_missing_target": "요청된 ID가 포함된 메시지에 수신자(주제 또는 사용자 또는 대상)가 없습니다.",
    "message_already_sent": "요청된 ID가 포함된 메시지가 이미 전송되었습니다.",
    "message_already_processing": "요청된 ID가 포함된 메시지가 이미 처리 중입니다.",
    "message_already_failed": "요청된 ID의 메시지가 이미 실패했습니다.",
    "message_already_scheduled": "요청된 ID가 포함된 메시지가 이미 배달 예약되었습니다.",
    "message_target_not_email": "대상 ID가 있는 메시지는 이메일 대상이 아닙니다.",
    "message_target_not_sms": "대상 ID가 있는 메시지는 SMS 대상이 아닙니다.",
    "message_target_not_push": "대상 ID가 있는 메시지는 푸시 대상이 아닙니다.",
    "message_missing_schedule": "일정이 없는 메시지는 '예약됨' 상태를 가질 수 없습니다.",
    "schedule_not_found": "요청하신 ID의 스케줄을 찾을 수 없습니다.",
    "target_provider_invalid_type": "Target에 잘못된 공급자 유형이 있습니다."
}